/**
 * @generated SignedSource<<33df82ae6f8f66901c2d8f98da83140d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReservationStatus = "CANCELLED" | "CHECKED_OUT" | "CONFIRMED" | "DRAFT" | "PICKED" | "REQUESTED" | "RETURNED" | "%future added value";
export type ClientPortalQuery$variables = Record<PropertyKey, never>;
export type ClientPortalQuery$data = {
  readonly facebookLoginEnabled: boolean;
  readonly viewer: {
    readonly engagements: ReadonlyArray<{
      readonly createdAt: any;
      readonly id: string;
      readonly interests: ReadonlyArray<string>;
      readonly projectName: string | null | undefined;
      readonly status: string;
    }>;
    readonly id: string;
    readonly image: string | null | undefined;
    readonly name: string | null | undefined;
    readonly reservations: ReadonlyArray<{
      readonly days: number;
      readonly endsAt: any;
      readonly id: string;
      readonly lines: ReadonlyArray<{
        readonly asset: {
          readonly name: string;
        };
        readonly id: string;
      }>;
      readonly quotedTotal: any | null | undefined;
      readonly startsAt: any;
      readonly status: ReservationStatus;
    }>;
  } | null | undefined;
};
export type ClientPortalQuery = {
  response: ClientPortalQuery$data;
  variables: ClientPortalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startsAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "days",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quotedTotal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Engagement",
  "kind": "LinkedField",
  "name": "engagements",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interests",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookLoginEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientPortalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Reservation",
            "kind": "LinkedField",
            "name": "reservations",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReservationLine",
                "kind": "LinkedField",
                "name": "lines",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ClientPortalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Reservation",
            "kind": "LinkedField",
            "name": "reservations",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReservationLine",
                "kind": "LinkedField",
                "name": "lines",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Asset",
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/)
    ]
  },
  "params": {
    "cacheID": "2d79e16598afc4be7563483a894fe063",
    "id": null,
    "metadata": {},
    "name": "ClientPortalQuery",
    "operationKind": "query",
    "text": "query ClientPortalQuery {\n  viewer {\n    id\n    name\n    image\n    reservations {\n      id\n      status\n      startsAt\n      endsAt\n      days\n      quotedTotal\n      lines {\n        id\n        asset {\n          name\n          id\n        }\n      }\n    }\n    engagements {\n      id\n      interests\n      projectName\n      status\n      createdAt\n    }\n  }\n  facebookLoginEnabled\n}\n"
  }
};
})();

(node as any).hash = "8daadcb4975e39d9c2e351956cef1bdb";

export default node;
